import React from "react";
import HeaderFour from "../../components/Header/HeaderFour";
import ChairmanMessageMain from "./ChairmanMessageMain";
import Footer from "../../components/Footer";

const ChairmanMessage = () => {
  return (
    <>
      <HeaderFour />
      <ChairmanMessageMain />
      <Footer />
    </>
  );
};

export default ChairmanMessage;
